import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ClinicPayments from '@/components/clinic/ClinicPayments';
import InvoicesPage from '@/pages/InvoicesPage';
import PracticeProductsPage from '@/pages/PracticeProductsPage';
import {
  CommissionConfigPage,
  CommissionStatementsPage,
  CommissionPayoutsPage,
} from '@/components/commissions';
import { useSearchParams } from 'react-router-dom';

const FinancialsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'payments';

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Financials</h1>
        <p className="text-sm text-slate-500 mt-1">Manage payments, invoices, practice products, and commissions.</p>
      </div>

      <Tabs defaultValue={defaultTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="border-b border-slate-200 bg-transparent h-auto p-0 space-x-0 w-full justify-start rounded-none">
          <TabsTrigger
            value="payments"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Payments
          </TabsTrigger>
          <TabsTrigger
            value="invoices"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Invoices
          </TabsTrigger>
          <TabsTrigger
            value="practice-products"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Practice Products
          </TabsTrigger>
          <TabsTrigger
            value="commission-rates"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Commission Rates
          </TabsTrigger>
          <TabsTrigger
            value="commission-statements"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Statements
          </TabsTrigger>
          <TabsTrigger
            value="commission-payouts"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Payouts
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="payments" className="m-0">
            <ClinicPayments />
          </TabsContent>
          <TabsContent value="invoices" className="m-0">
            <InvoicesPage />
          </TabsContent>
          <TabsContent value="practice-products" className="m-0">
            <PracticeProductsPage />
          </TabsContent>
          <TabsContent value="commission-rates" className="m-0">
            <CommissionConfigPage />
          </TabsContent>
          <TabsContent value="commission-statements" className="m-0">
            <CommissionStatementsPage />
          </TabsContent>
          <TabsContent value="commission-payouts" className="m-0">
            <CommissionPayoutsPage />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default FinancialsPage;
